import Standard from './Standard';
import StandardBrowseV2 from '../Standard.browsev2_thumbs';
import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
export default withFeatureBranch({ browsev2_thumbs: StandardBrowseV2 })(Standard);
//# sourceMappingURL=index.js.map